{
  "dashboard": "Dashboard",
  "client": "Client",
  "clientSummary": "View currently selected client summary information and/or launch another client",
  "users": "Users",
  "usersSummary": "Manage user accounts and permissions within the system",
  "batchDeploy": "Deploy Batch Job",
  "batchDeploySummary": "Configure and launch a batch deployment job to process large data sets",
  "systems": "Systems",
  "systemSummary": "Sub-sets of attributes logically organized into groups supporting deployment and tools management",
  "sttributes": "Attributes",
  "attributesSummary": "Leveled characteristics derived from one or more filters and/or attributes and used in one or more systems",
  "filters": "Filters",
  "filtersSummary": "Normalized components of attributes derived from one or more raw data and/or filters and used in one or more attributes",
  "tools": "Tools",
  "toolsSummary": "Group of ATB management features including Import, Export, Report and Multi Data Source",
  "clientSelection": "Client Selection",
  "clientSelectionDescription": "Please select the client you would like to use from those available below :",
  "clientList": "Client List:",
  "creditAttributeTracker": "Credit Attribute Tracker",
  "creditAttributeTrackerSummary": "A cloud-based Tableau® reporting system that enables you to make smart, data-driven decisions with access to flexible reports",
  "engineDeploy": "Deploy ATB Engine",
  "engineDeploySummary": "Deploy AMS coded attributes to the ATB Engine web service"
}
